// extracted by mini-css-extract-plugin
module.exports = {"popupName":"basic_popupName__Y4mP8","popupClose":"basic_popupClose__RilMN"};